import { useEffect, useState } from 'react';

import { useAccountSettings } from '~/components/api/useAccountSettings';

import { FilterLogsArguments } from '../types';
import { getLogsUrl } from './util';

export function useLogs({ api, type, status, query }: FilterLogsArguments) {
  const { secretToken } = useAccountSettings();
  const [logs, setLogs] = useState(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    async function fetchLogs() {
      if (!secretToken) {
        return;
      }

      const fullUrl = getLogsUrl({ api, type, status, query });
      const response = await fetch(fullUrl, {
        headers: {
          Authorization: `Bearer ${secretToken}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setLogs(data);
        setHasError(false);
      } else {
        setLogs(null);
        setHasError(true);
      }
    }

    fetchLogs();
  }, [secretToken, api, type, status]);

  return {
    secretToken,
    logs,
    hasError,
  };
}
